import axiosInstance from "api/axios";
import { Charge, ChargeCreationAttributes } from "../types/charge.type";

interface GetAllParams {
  page?: number;
  limit?: number;
  search?: string;
  dateFrom?: string;
  dateTo?: string;
  subCompanyId?: number | null;
}

export const chargeService = {
  // create a new charge
  create: async (data: ChargeCreationAttributes) => {
    const response = await axiosInstance.post("/charge", data);
    return response.data;
  },

  // get all charges
  getAll: async (
    params?: GetAllParams
  ): Promise<{ rows: Charge[]; count: number }> => {
    const response = await axiosInstance.get("/charge", { params });
    return response.data;
  },

  // get archived charges
  getArchived: async () => {
    const response = await axiosInstance.get("/charge/archived");
    return response.data;
  },

  // get a single charge by ID
  getById: async (id: number) => {
    const response = await axiosInstance.get(`/charge/${id}`);
    return response.data;
  },

  // update a charge
  update: async (id: number, data: Partial<Charge>) => {
    const response = await axiosInstance.put(`/charge/${id}`, data);
    return response.data;
  },

  // delete a charge
  delete: async (id: number) => {
    const response = await axiosInstance.delete(`/charge/${id}`);
    return response.data;
  },
};
